export default __webpack_public_path__ + "static/media/img16.7c32a151.jpg";